import React, { Fragment } from "react";
import DriveUpload from "./DriveUpload";
import DropboxUpload from "./Dropbox";

const UploadResume = (props) => {

    return (
        <Fragment>
            <div id="resumeReceiveError">
                <h3>Upload your resume</h3>
                <div id="resumeOptionsGroup" style={ (props.hostedType.toLowerCase() === "hosted" || props.hostedType.toLowerCase() === "hosted_plus") ? { marginBottom:'25px' } : {}}>
                    <button type="button" id="FileUploadResumeButton" className="btn btnClear btnBordered resumeSelectButton btnSmall btn-sm" onClick={() => props.onFormSubmit('uploadFile')} ><span className="glyphicon glyphicon-upload" ></span> Upload File</button><br />
                    <DropboxUpload keyMapId={props.keyMapId} sid={props.SID} siteId={props.siteId} cid={props.cid} zip={props.zip} hostedType={props.hostedType} onFormSubmit={props.onFormSubmit} updateResumeFileName={props.updateResumeFileName} loading={props.loading} showLoad={props.showLoad} hideLoad={props.hideLoad} queryString3={props.queryString3}/>
                    <br /> 
                    <DriveUpload keyMapId={props.keyMapId} sid={props.SID} siteId={props.siteId} cid={props.cid} zip={props.zip} hostedType={props.hostedType} onFormSubmit={props.onFormSubmit} updateResumeFileName={props.updateResumeFileName} loading={props.loading} showLoad={props.showLoad} hideLoad={props.hideLoad} queryString3={props.queryString3}/>     
                </div>
                {
                    (props.hostedType.toLowerCase() === "direct" || (!props.hostedType.toLowerCase() === "hosted" && !props.hostedType.toLowerCase() === "hosted_plus") ||  (props.hostedType.toLowerCase() === ""))
                    &&
                    <p>Don't have a resume...<a href="#" onClick={() => props.onFormSubmit('easyApply')}>Click Here</a></p>
                }
            </div>
        </Fragment>
    )

}

export default UploadResume;